// extracted by mini-css-extract-plugin
export default {"footer":"PageFooter_footer__9r0Au","button":"PageFooter_button__7jEBE"};